import { axios, def, handleError } from './internal';

function AdminAnalytics(setData, days, service = 'loise') {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_analytics', { days, service })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data ?? [] });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

function AdminHourly(setData, hours) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_hourly', { hours })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data ?? [] });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

function AdminDaily(setData, days) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_daily', { days })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data ?? [] });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

function AdminWeekly(setData, days) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_weekly', { days })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, rows: res.data.data ?? [] });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

export { AdminAnalytics, AdminDaily, AdminHourly, AdminWeekly };
